(function () {
  let makeLogoMap = null;

  function getMakeLogoMap() {
    if (makeLogoMap) return makeLogoMap;

    makeLogoMap = new Map();
    const registry = document.getElementById('menu-make-logos');
    if (!registry) return makeLogoMap;

    registry.querySelectorAll('[data-make-logo]').forEach((entry) => {
      const title = entry.dataset.title?.trim().toLowerCase();
      if (!title || !entry.dataset.src) return;
      makeLogoMap.set(title, {
        src: entry.dataset.src,
        alt: entry.dataset.alt || title,
      });
    });

    return makeLogoMap;
  }

  function initScrollAreas(root) {
    root.querySelectorAll('[data-mega-menu-scroll]').forEach((scrollEl) => {
      if (scrollEl.dataset.scrollInitialized === 'true') return;
      scrollEl.dataset.scrollInitialized = 'true';

      let scheduled = false;
      let scrollLockTimer = null;

      const lockScrollInteraction = () => {
        if (!scrollEl.hasAttribute('data-scroll-lock')) return;
        scrollEl.classList.add('is-scrolling');
        clearTimeout(scrollLockTimer);
        scrollLockTimer = setTimeout(() => {
          scrollEl.classList.remove('is-scrolling');
        }, 250);
      };

      const update = () => {
        if (scheduled) return;
        scheduled = true;
        requestAnimationFrame(() => {
          scheduled = false;
          const { scrollTop, scrollHeight, clientHeight } = scrollEl;
          scrollEl.classList.toggle('has-scroll-below', scrollTop + clientHeight < scrollHeight - 4);
        });
      };

      scrollEl._scrollUpdate = update;

      if (scrollEl.hasAttribute('data-scroll-lock')) {
        scrollEl.addEventListener('wheel', lockScrollInteraction, { passive: true });
      }

      scrollEl.addEventListener(
        'scroll',
        () => {
          lockScrollInteraction();
          update();
        },
        { passive: true }
      );

      update();
    });
  }

  function resetScrollArea(root, selector) {
    const scrollEl = root.querySelector(selector);
    if (!scrollEl) return;
    scrollEl.scrollTop = 0;
    scrollEl._scrollUpdate?.();
  }

  function initMegaMenuTieredCar(root) {
    if (!root || root.dataset.tieredCarInitialized === 'true') return;
    root.dataset.tieredCarInitialized = 'true';

    initScrollAreas(root);

    const makeItems = root.querySelectorAll('.mega-menu-tiered__make-item[data-make-index]');
    const makePanels = root.querySelectorAll('[data-make-panel].mega-menu-tiered__series-panel');
    const seriesItems = root.querySelectorAll('.mega-menu-tiered__series-item[data-series-index]');
    const modelPanels = root.querySelectorAll('[data-series-panel].mega-menu-tiered__models-panel');
    const makeHeading = root.querySelector('[data-mega-menu-make-heading]');
    const seriesHeading = root.querySelector('[data-mega-menu-series-heading]');
    const makesList = root.querySelector('.mega-menu-tiered__makes-list');
    const makesScroll = root.querySelector('.mega-menu-tiered__scroll--makes');

    if (!makeItems.length || !makesList) return;

    const makeItemByIndex = new Map();
    const makePanelByIndex = new Map();
    const seriesItemByKey = new Map();
    const modelPanelByKey = new Map();

    makeItems.forEach((item) => {
      makeItemByIndex.set(parseInt(item.dataset.makeIndex, 10), item);
    });

    makePanels.forEach((panel) => {
      makePanelByIndex.set(parseInt(panel.dataset.makePanel, 10), panel);
    });

    seriesItems.forEach((item) => {
      const key = `${item.dataset.makeIndex}-${item.dataset.seriesIndex}`;
      seriesItemByKey.set(key, item);
    });

    modelPanels.forEach((panel) => {
      const key = `${panel.dataset.makePanel}-${panel.dataset.seriesPanel}`;
      modelPanelByKey.set(key, panel);
    });

    let activeMakeIndex = null;
    let activeSeriesKey = null;
    let activeMakeItem = null;
    let activeMakePanel = null;
    let activeSeriesItem = null;
    let activeModelPanel = null;
    let makeHoverTimer = null;

    function getItemTitle(item) {
      return (
        item.dataset.makeTitle ||
        item.dataset.seriesTitle ||
        item.querySelector('.mega-menu-tiered__make-item-text, .mega-menu-tiered__series-item-text')?.textContent?.trim() ||
        ''
      );
    }

    function setMakeItemActive(item, isActive) {
      item.classList.toggle('is-active', isActive);
      if (item.hasAttribute('aria-controls')) {
        item.setAttribute('aria-expanded', isActive ? 'true' : 'false');
      }
    }

    function setSeriesItemActive(item, isActive) {
      item.classList.toggle('is-active', isActive);
      if (item.hasAttribute('aria-controls')) {
        item.setAttribute('aria-expanded', isActive ? 'true' : 'false');
      }
    }

    function showPanel(panel) {
      panel.classList.add('is-active');
      panel.removeAttribute('hidden');
    }

    function hidePanel(panel) {
      panel.classList.remove('is-active');
      panel.setAttribute('hidden', '');
    }

    function clearSeriesModelSelection() {
      if (activeSeriesItem) {
        setSeriesItemActive(activeSeriesItem, false);
        activeSeriesItem = null;
      }

      if (activeModelPanel) {
        hidePanel(activeModelPanel);
        activeModelPanel = null;
      }

      activeSeriesKey = null;

      if (seriesHeading) {
        seriesHeading.textContent = '';
      }

      resetScrollArea(root, '.mega-menu-tiered__scroll--models');
      root.querySelector('.mega-menu-tiered__scroll--series')?._scrollUpdate?.();
      root.querySelector('.mega-menu-tiered__scroll--models')?._scrollUpdate?.();
    }

    function activateSeries(makeIndex, seriesIndex, force) {
      const seriesKey = `${makeIndex}-${seriesIndex}`;
      if (!force && activeSeriesKey === seriesKey) return;

      const nextSeriesItem = seriesItemByKey.get(seriesKey);
      const nextModelPanel = modelPanelByKey.get(seriesKey);
      if (!nextSeriesItem || !nextModelPanel) return;

      if (activeSeriesItem && activeSeriesItem !== nextSeriesItem) {
        setSeriesItemActive(activeSeriesItem, false);
      }

      if (activeModelPanel && activeModelPanel !== nextModelPanel) {
        hidePanel(activeModelPanel);
      }

      activeSeriesKey = seriesKey;
      activeSeriesItem = nextSeriesItem;
      activeModelPanel = nextModelPanel;

      setSeriesItemActive(nextSeriesItem, true);
      showPanel(nextModelPanel);

      if (seriesHeading) {
        seriesHeading.textContent = getItemTitle(nextSeriesItem);
      }

      resetScrollArea(root, '.mega-menu-tiered__scroll--models');
      root.querySelector('.mega-menu-tiered__scroll--series')?._scrollUpdate?.();
      root.querySelector('.mega-menu-tiered__scroll--models')?._scrollUpdate?.();
    }

    function activateMake(makeIndex, options = {}) {
      const selectFirstSeries = options.selectFirstSeries === true;

      if (!selectFirstSeries && activeMakeIndex === makeIndex) return;

      const nextMakeItem = makeItemByIndex.get(makeIndex);
      const nextMakePanel = makePanelByIndex.get(makeIndex);
      if (!nextMakeItem || !nextMakePanel) return;

      if (activeMakeItem && activeMakeItem !== nextMakeItem) {
        setMakeItemActive(activeMakeItem, false);
      }

      if (activeMakePanel && activeMakePanel !== nextMakePanel) {
        hidePanel(activeMakePanel);
      }

      activeMakeIndex = makeIndex;
      activeMakeItem = nextMakeItem;
      activeMakePanel = nextMakePanel;

      setMakeItemActive(nextMakeItem, true);
      showPanel(nextMakePanel);

      if (makeHeading) {
        makeHeading.textContent = getItemTitle(nextMakeItem);
      }

      resetScrollArea(root, '.mega-menu-tiered__scroll--series');
      clearSeriesModelSelection();

      if (selectFirstSeries) {
        const firstSeries = nextMakePanel.querySelector('.mega-menu-tiered__series-item[data-series-index]');
        if (firstSeries) {
          activateSeries(makeIndex, parseInt(firstSeries.dataset.seriesIndex, 10), true);
        } else {
          root.querySelector('.mega-menu-tiered__scroll--series')?._scrollUpdate?.();
        }
      } else {
        root.querySelector('.mega-menu-tiered__scroll--series')?._scrollUpdate?.();
      }
    }

    function isMakesScrolling() {
      return makesScroll?.classList.contains('is-scrolling');
    }

    function scheduleMakeActivate(makeIndex) {
      clearTimeout(makeHoverTimer);
      if (isMakesScrolling()) return;

      makeHoverTimer = setTimeout(() => {
        if (isMakesScrolling()) return;
        activateMake(makeIndex);
      }, 80);
    }

    makesList.addEventListener('mouseover', (event) => {
      const item = event.target.closest('.mega-menu-tiered__make-item[data-make-index]');
      if (!item || !makesList.contains(item)) return;

      const related = event.relatedTarget;
      if (related instanceof Node && item.contains(related)) return;

      scheduleMakeActivate(parseInt(item.dataset.makeIndex, 10));
    });

    makesList.addEventListener('mouseleave', () => {
      clearTimeout(makeHoverTimer);
    });

    root.addEventListener('mouseover', (event) => {
      const item = event.target.closest('.mega-menu-tiered__series-item[data-series-index]');
      if (!item || !root.contains(item)) return;

      const related = event.relatedTarget;
      if (related instanceof Node && item.contains(related)) return;

      const seriesScroll = item.closest('.mega-menu-tiered__scroll--series');
      if (seriesScroll?.classList.contains('is-scrolling')) return;

      activateSeries(parseInt(item.dataset.makeIndex, 10), parseInt(item.dataset.seriesIndex, 10));
    });

    root.addEventListener('click', (event) => {
      const item = event.target.closest('.mega-menu-tiered__series-item[data-series-index]');
      if (!item || !root.contains(item)) return;
      event.preventDefault();
      activateSeries(parseInt(item.dataset.makeIndex, 10), parseInt(item.dataset.seriesIndex, 10));
    });

    const firstMakeIndex = parseInt(makeItems[0].dataset.makeIndex, 10);
    activateMake(firstMakeIndex, { selectFirstSeries: true });
  }

  function bindLazyCarMenuInit() {
    document.querySelectorAll('.mega-menu--shop-by-car').forEach((menu) => {
      if (menu.dataset.carLazyInitBound === 'true') return;
      menu.dataset.carLazyInitBound = 'true';

      const init = () => {
        const root = menu.querySelector('[data-mega-menu-tiered-car]');
        if (root) initMegaMenuTieredCar(root);
      };

      menu.addEventListener('toggle', () => {
        if (menu.open) init();
      });

      menu.addEventListener('mouseenter', init, { once: true });
    });
  }

  function onSectionRefresh() {
    makeLogoMap = null;
    bindLazyCarMenuInit();
    document.querySelectorAll('[data-mega-menu-tiered-car]').forEach((root) => {
      if (root.dataset.tieredCarInitialized === 'true') return;
      const menu = root.closest('.mega-menu--shop-by-car');
      if (menu?.open || menu?.matches(':hover')) {
        initMegaMenuTieredCar(root);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindLazyCarMenuInit);
  } else {
    bindLazyCarMenuInit();
  }

  document.addEventListener('shopify:section:load', onSectionRefresh);
  document.addEventListener('section:cached', onSectionRefresh);
})();
